import { render, staticRenderFns } from "./pendingBetListOthersTab.vue?vue&type=template&id=47f5830e&lang=pug"
import script from "./pendingBetListOthersTab.vue?vue&type=script&lang=js"
export * from "./pendingBetListOthersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports